import {sItemKeyToInt} from '../models-old/datastructures';
import {IFirebaseQuery} from '../../shared/shared-models/firebase/firebase-queries';

/**
 * @constant subQueryStock
 * A query that is used to retrieve data from the DB.
 * This relates to Stock 2.
 */
export const subQueryStock: IFirebaseQuery[] = [
  {q: 'where', p: ['_tags', 'array-contains', 'in_ngp']},
  {q: 'orderBy', p: [sItemKeyToInt.suppUsedLastDate1]},
];

export const subQueryStockShelfTalkers: IFirebaseQuery[] = [
  {q: 'where', p: ['_tags', 'array-contains', 'in_shelf_talkers']},
];
export const subQueryStockShelfTalkersExceptions: IFirebaseQuery[] = [
  {q: 'where', p: ['_tags', 'array-contains', 'shelf_talker_exception']},
];
